import { render, staticRenderFns } from "./LotsTab.vue?vue&type=template&id=9e9e59ae"
import script from "./LotsTab.vue?vue&type=script&lang=js"
export * from "./LotsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports